import { useQuery } from "react-query";
import { RestError } from "../../services/rest-service/RestService";
import { IUserPermission } from "../../services/user-role-administration-service/Models";
import UserRoleAdministrationService from "../../services/user-role-administration-service/UserRoleAdministrationService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { keys } from "./Keys";

export type UseUserPermissionsReportParameters = {
    organizationID: number;
    groupID: number;
} & BaseUseQueryParameters<IUserPermission[]>;

export function useUserPermissionsReport({
    organizationID,
    groupID,
    enabled,
    onError,
    onSuccess
}: UseUserPermissionsReportParameters) {
    return useQuery<IUserPermission[], RestError, IUserPermission[]>(
        keys.userPermissionsReport(organizationID, groupID),
        ({ signal }) => {
            return UserRoleAdministrationService.getUserPermissionsReport(organizationID, groupID, signal);
        },
        {
            enabled,
            onError,
            onSuccess,
            staleTime: 0
        }
    );
}
